export const categories = [
  {
    name: "Sustainability & Green Engineering",
    icon: "🌿",
    factors: [
      { label: "Sustainability Pressure", emoji: "🌿", key: "sustainabilityPressure" },
      { label: "ESG & CSRD Compliance", emoji: "📘", key: "esgCompliance" },
      { label: "Green Product Innovation", emoji: "🧪", key: "greenProductInnovation" },
      { label: "Supply Chain Circularity", emoji: "♻️", key: "supplyChainCircularity" },
    ]
  },
  {
    name: "Supply Chain & Supplier Collaboration",
    icon: "🔗",
    factors: [
      { label: "Supplier Dependency", emoji: "🏗️", key: "supplierDependency" },
      { label: "Collaboration Need", emoji: "🤝", key: "collaborationNeed" },
      { label: "Geographic Spread", emoji: "🌍", key: "geographicSpread" },
      { label: "Supplier Tools Gap", emoji: "🛠️", key: "supplierToolsGap" },
      { label: "Supplier SLA Pressure", emoji: "📑", key: "supplierSlaPressure" },
      { label: "Partner Ecosystem Maturity", emoji: "🌐", key: "partnerEcosystemMaturity" },
    ]
  },
  {
    name: "Strategic Value & Business Model Impact",
    icon: "📊",
    factors: [
      { label: "Service Revenue", emoji: "🔧", key: "serviceRevenue" },
      { label: "Business Model Shift", emoji: "💼", key: "businessModelShift" },
      { label: "Lifecycle Monetization", emoji: "💰", key: "lifecycleMonetization" },
      { label: "Digital Thread Monetization", emoji: "🧵", key: "digitalThreadMonetization" },
      { label: "IP Portfolio Leverage", emoji: "🧠", key: "ipPortfolioLeverage" },
      { label: "Program Margin Uplift", emoji: "📈", key: "programMarginUplift" },
      { label: "IP Capitalization Readiness", emoji: "🪙", key: "ipCapitalizationReadiness" },
    ]
  },
  {
    name: "Risk, Security & Resilience",
    icon: "🛡️",
    factors: [
      { label: "M&A Frequency", emoji: "🔀", key: "maFrequency" },
      { label: "Localization Demand", emoji: "🌐", key: "localizationDemand" },
      { label: "Technical Debt", emoji: "💣", key: "technicalDebt" },
      { label: "Engineering IP Risk", emoji: "⚠️", key: "engineeringIpRisk" },
      { label: "Migration Complexity", emoji: "🧱", key: "migrationComplexity" },
      { label: "Cybersecurity Exposure", emoji: "🛡️", key: "cybersecurityExposure" },
      { label: "Resilience Requirement", emoji: "🏔️", key: "resilienceRequirement" },
      { label: "Revenue Resilience", emoji: "📉", key: "revenueResilience" },
    ]
  },
  {
    name: "Product & Engineering Complexity",
    icon: "🧩",
    factors: [
      { label: "Product Complexity", emoji: "🔬", key: "productComplexity" },
      { label: "Change Frequency", emoji: "🔄", key: "changeFrequency" },
      { label: "Volume-Variety Mix", emoji: "📦", key: "volumeVarietyMix" },
      { label: "CAD Intensity", emoji: "📐", key: "cadIntensity" },
      { label: "Lifecycle Length", emoji: "⏳", key: "lifecycleLength" },
      { label: "Reuse Potential", emoji: "♻️", key: "reusePotential" },
      { label: "Part Count", emoji: "🔩", key: "partCount" },
      { label: "Product Configurability", emoji: "🛠️", key: "productConfigurability" },
      { label: "Portfolio Breadth", emoji: "🧰", key: "portfolioBreadth" },
      { label: "Program Duration", emoji: "📅", key: "programDuration" },
      { label: "Cross-Domain Need", emoji: "🧠", key: "crossDomainNeed" },
      { label: "Sensorization Level", emoji: "📡", key: "sensorizationLevel" },
      { label: "Product-as-a-Platform", emoji: "🧱", key: "productAsPlatform" },
    ]
  },
  {
    name: "Process Maturity & Efficiency",
    icon: "🧪",
    factors: [
      { label: "Legacy Process Gap", emoji: "🕰️", key: "legacyProcessGap" },
      { label: "Digital Maturity", emoji: "🧠", key: "digitalMaturity" },
      { label: "Infra Readiness", emoji: "🖥️", key: "infraReadiness" },
      { label: "Tool Fragmentation", emoji: "🔧", key: "toolFragmentation" },
      { label: "Manual Exceptions", emoji: "📎", key: "manualExceptions" },
      { label: "System Automation", emoji: "⚙️", key: "systemAutomation" },
      { label: "Exception Volume", emoji: "🚨", key: "exceptionVolume" },
      { label: "Test Infrastructure", emoji: "🧪", key: "testInfrastructure" },
      { label: "Legacy Customization Debt", emoji: "🔌", key: "legacyCustomizationDebt" },
      { label: "Digital Thread Continuity", emoji: "🧵", key: "digitalThreadContinuity" },
    ]
  },
  {
    name: "People, Talent & Cultural Readiness",
    icon: "👥",
    factors: [
      { label: "Skill Diversity", emoji: "🧠", key: "skillDiversity" },
      { label: "User Buy-in", emoji: "🙋", key: "userBuyIn" },
      { label: "Change Resistance", emoji: "🛑", key: "changeResistance" },
      { label: "PLM Talent Availability", emoji: "👨‍💻", key: "plmTalentAvailability" },
    ]
  },
  {
    name: "Integration, Interoperability & Platform",
    icon: "🔌",
    factors: [
      { label: "Integration Depth", emoji: "🔗", key: "integrationDepth" },
      { label: "Cloud Ops Discipline", emoji: "☁️", key: "cloudOpsDiscipline" },
      { label: "Event-Driven Integration", emoji: "📣", key: "eventDrivenIntegration" },
      { label: "Digital Twin Convergence", emoji: "🧠", key: "digitalTwinConvergence" },
      { label: "Data Latency Tolerance", emoji: "⏱️", key: "dataLatencyTolerance" },
      { label: "Ecosystem Licensing Strategy", emoji: "🔏", key: "ecosystemLicensingStrategy" },
      { label: "Cross-PLM Interoperability", emoji: "🧩", key: "crossPlmInteroperability" },
      { label: "Platform Ecosystem Participation", emoji: "🧭", key: "platformEcosystemParticipation" },
    ]
  },
  {
    name: "Customer-Centricity & Market Fit",
    icon: "🎯",
    factors: [
      { label: "Speed Sensitivity", emoji: "⚡", key: "speedSensitivity" },
      { label: "Competitive Pressure", emoji: "📉", key: "competitivePressure" },
      { label: "Innovation Throughput", emoji: "💡", key: "innovationThroughput" },
      { label: "Customer Feedback Loop", emoji: "📬", key: "customerFeedbackLoop" },
      { label: "Time-to-Value (TTV) Acceleration", emoji: "🚀", key: "ttvAcceleration" },
      { label: "Customer Co-Creation Capability", emoji: "👥", key: "customerCoCreation" },
    ]
  },
  {
    name: "Compliance, Traceability & Governance",
    icon: "📜",
    factors: [
      { label: "Regulatory Burden", emoji: "⚖️", key: "regulatoryBurden" },
      { label: "Recall Risk", emoji: "🚨", key: "recallRisk" },
      { label: "Traceability Need", emoji: "🔍", key: "traceabilityNeed" },
      { label: "Compliance Penalty", emoji: "💸", key: "compliancePenalty" },
      { label: "Naming Discipline", emoji: "📝", key: "namingDiscipline" },
      { label: "Data Governance Quality", emoji: "📊", key: "dataGovernanceQuality" },
      { label: "End-to-End Traceability", emoji: "🧵", key: "endToEndTraceability" },
      { label: "Data Provenance", emoji: "🧬", key: "dataProvenance" },
      { label: "Regulatory Audit Readiness", emoji: "🧾", key: "regulatoryAuditReadiness" },
    ]
  },
  {
    name: "Change & Configuration Impact",
    icon: "🔁",
    factors: [
      { label: "Error Cost", emoji: "⚠️", key: "errorCost" },
      { label: "Delay Penalty", emoji: "⏰", key: "delayPenalty" },
      { label: "Engineering Cost", emoji: "💵", key: "engineeringCost" },
      { label: "Reuse Library", emoji: "📚", key: "reuseLibrary" },
      { label: "IP Risk", emoji: "🔓", key: "ipRisk" },
      { label: "Aftermarket Focus", emoji: "🛠️", key: "aftermarketFocus" },
    ]
  },
  {
    name: "AI, Analytics & Automation Readiness",
    icon: "🤖",
    factors: [
      { label: "AI Readiness", emoji: "🧠", key: "aiReadiness" },
      { label: "Analytics Capability", emoji: "📈", key: "analyticsCapability" },
      { label: "AI Co-Design Adoption", emoji: "🤝", key: "aiCoDesignAdoption" },
      { label: "Intelligent Workflow Orchestration", emoji: "🔁", key: "intelligentWorkflowOrchestration" },
    ]
  }
];
